module.exports = __webpack_public_path__ + "img/service-1.805dfa98.png";